'use strict';

import $ from 'jquery';
import mask from 'jquery-mask-plugin';
import Swal from 'sweetalert2';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    remove_register: 'Excluir registro?',
    remove_register_text: 'Tem certeza que deseja remover este registro?',
    remove_confirm: 'Sim, excluir registro!',
    remove_cancel: 'Não excluir',
    blocked_content: 'Você precisa realizar o seu login na plataforma para visualizar essas informações.',
  },
  en: {
    remove_register: 'Delete record?',
    remove_register_text: 'Are you sure you want to remove this record?',
    remove_confirm: 'Yes, delete record!',
    remove_cancel: 'Do not delete',
    blocked_content: 'You need to log in to the platform to view this information.',
  },
  es: {
    remove_register: '¿Eliminar el registro?',
    remove_register_text: '¿Está seguro de que desea eliminar este registro?',
    remove_confirm: '¡Sí, eliminar registro!',
    remove_cancel: 'No borres',
    blocked_content: 'Debe iniciar sesión en la plataforma para ver esta información.',
  },
};

const common = {
  settings: {
    $selectSuper: $('.js-superintendent'),
    $selectRegional: $('.js-regional'),
  },

  init() {
    const $modalTrigger = document.getElementById('modal-trigger');

    if ($modalTrigger) {
      const title = $modalTrigger.getAttribute('data-title'),
        type = $modalTrigger.getAttribute('data-type'),
        text = $modalTrigger.getAttribute('data-text');

      Swal.fire({ title: `${title ? title : ''}`, text: `${text ? text : ''}`, icon: `${type ? type : ''}` });
    }

    $('.js-dropup-trigger').on('click', function () {
      this.parentElement.classList.toggle('active');
    });

    $(document).on('click', function () {
      $('.c-dropup').removeClass('active');
    });

    $('.c-dropup').on('click', function (e) {
      e.stopPropagation();
    });

    // Email Protective SPAM Solution
    const $mailContainer = document.querySelectorAll('[data-mail-creator]');

    if ($mailContainer.length) {
      $mailContainer.forEach(el => {
        let $mail = document.createElement('a');
        let arrMail = el.getAttribute('data-mail-creator').split(',');

        if (arrMail.length == 3) {
          let label =
            arrMail[0].replace(/\s/g, '') + '@' + arrMail[1].replace(/\s/g, '') + arrMail[2].replace(/\s/g, '');
          $mail.setAttribute('href', 'ma' + 'il' + 'to:' + label);
          $mail.textContent = label;
          el.appendChild($mail);
        }
      });
    }

    //Toggle Menu
    document.querySelector('.js-toggle-menu').addEventListener('click', e => {
      e.preventDefault();
      document.body.classList.toggle('nav-active');
    });

    //Delete register
    $(document).on('click', '.js-delete', function (e) {
      e.preventDefault();
      let data_id = $(this).attr('data-id');

      Swal.fire({
        title: tr[lang].remove_register,
        text: tr[lang].remove_register_text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: tr[lang].remove_confirm,
        cancelButtonText: tr[lang].remove_cancel,
      }).then(result => {
        if (result.value) {
          var token = $('meta[name="csrf-token"]').attr('content');

          $.ajax({
            headers: {
              'X-CSRF-TOKEN': token,
            },
            url: $(this).attr('data-url'),
            method: 'DELETE',
            success: function (data) {
              Swal.fire(data.title, data.message, data.type);

              if (data.type == 'success') {
                var row = document.getElementById(data_id);
                row.parentNode.removeChild(row);
              }
            },
          });
        }
      });
    });

    //Custom delete register
    $(document).on('click', '.js-delete-custom', function (e) {
      e.preventDefault();
      let data_id = $(this).attr('data-id');
      let data_title = $(this).attr('data-message-title');
      let data_content = $(this).attr('data-message-content');

      Swal.fire({
        title: data_title,
        text: data_content,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: tr[lang].remove_confirm,
        cancelButtonText: tr[lang].remove_cancel,
      }).then(result => {
        if (result.value) {
          var token = $('meta[name="csrf-token"]').attr('content');

          $.ajax({
            headers: {
              'X-CSRF-TOKEN': token,
            },
            url: $(this).attr('data-url'),
            method: 'DELETE',
            success: function (data) {
              Swal.fire(data.title, data.message, data.type);

              if (data.type == 'success') {
                var row = document.getElementById(data_id);
                row.parentNode.removeChild(row);

                if ($('.js-counter').length && data.count) {
                  $('.js-counter').html(data.count);
                }

                if ($('.js-free-vacancies').length) {
                  var num = $('.js-free-vacancies').html();
                  $('.js-free-vacancies').html(parseInt(num) + 1);
                }
              }
            },
          });
        }
      });
    });

    $('.file-input').on('change', function () {
      $('#label_' + this.name).text(this.files[0].name);
    });

    s.$selectSuper.on('change', function (e) {
      e.preventDefault();

      var post = {};

      s.$selectRegional.empty();
      s.$selectRegional.append($('<option></option>').attr('value', '').text('Carregando...'));

      post.id = s.$selectSuper.val();
      post._token = $('meta[name="csrf-token"]').attr('content');

      var url = '/busca-regionais/' + post.id;

      $.ajax({
        type: 'GET',
        url: url,
        data: post,
        cache: false,
        dataType: 'json',
        success: function (data) {
          if (data) {
            s.$selectRegional.empty();

            s.$selectRegional.append($('<option></option>').attr('value', '0').text('Selecione sua regional'));
            $.each(data, function (index, element) {
              s.$selectRegional.append($('<option></option>').attr('value', index).text(element));
            });
          }
        },
      });
    });

    $(document).on('click', '.js-change-tab', function (e) {
      e.preventDefault();

      $('.tab').each(function () {
        $(this).removeClass('active');
      });

      $('#' + $(this).data('tab')).addClass('active');
    });

    $(document).on('click', '.js-send-email', function (e) {
      e.preventDefault();
      $('#tab-send-email').removeClass('u-display--none');
    });

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('action') == 'mail') {
      $('#tab-send-email').removeClass('u-display--none');
    }

    $(document).on('click', '.js-cancel-email', function (e) {
      e.preventDefault();

      $('#tab-send-email').addClass('u-display--none');
    });

    $(document).on('click', '[data-modal-close]', function () {
      $(this).closest('.c-modal').removeClass('is-active');
      $('#modal-form').remove();
    });

    $('.js-modal-warning-logged').on('click', function (e) {
      e.preventDefault();
      Swal.fire({
        html: `
          <h3 class="o-ttl">
            ${$(this).attr('data-title')}
          </h3>
          <p>${tr[lang].blocked_content}</p>`,
        padding: '25px 15px',
        position: 'top',
        showConfirmButton: false,
        showClass: {
          popup: 'c-new-swal--popup',
        },
        customClass: 'c-new-swal',
      });
    });

    const $customCheck = $('[data-custom-check]');

    $customCheck.on('click', function (e) {
      const $check = $(this).find('input[type="checkbox"]');

      let $status = 0;

      if ($($check).is(':checked')) {
        $check.prop('checked', false);
      } else {
        $check.prop('checked', true);
        $status = 1;
      }

      let url = $(this).attr('data-url');
      var post = {};
      post.receive_notifications = $status;
      post._token = $('meta[name="csrf-token"]').attr('content');

      $.ajax({
        type: 'POST',
        url: url,
        data: post,
        cache: false,
        dataType: 'json',
        success: function (data) {
          if (data.success) {
            Swal.fire(data.title, data.message, data.type);
          }
        },
      });
    });

    // Máscara de diversos inputs,
    // Função dispara no focus para contemplar elementos inseridos após o carregamento do JS
    // EX: formulários de ação
    $(document).on('focus', '.js-form-cnpj', function () {
      $(this).mask('99.999.999/9999-99');
    });
    $(document).on('focus', '.js-form-cpf', function () {
      $(this).mask('999.999.999-99');
    });
    $(document).on('focus', '.js-form-enrollment', function () {
      $(this).mask('99999999999', { clearIfNotMatch: true });
    });
    $(document).on('focus', '.js-form-date', function () {
      $(this).mask('99/99/9999');
    });
    $(document).on('focus', '.js-form-datetime', function () {
      $(this).mask('99/99/9999 99:99');
    });
    $(document).on('focus', '.js-form-hour', function () {
      $(this).mask('99:99');
    });
    $(document).on('focus', '.js-form-ddd', function () {
      $(this).mask('(99)');
    });
    $(document).on('focus', '.js-form-phone', function () {
      $(this).mask('(99) 99999.9999');
    });
    $(document).on('focus', '.js-form-phone-commercial', function () {
      $(this).mask('(99) 9999.9999');
    });
    $(document).on('focus', '.js-form-number', function () {
      $(this).mask('999999999999999');
    });
    $(document).on('focus', '.js-form-numeric-range', function () {
      $(this).mask('999999999999999');
    });
    $(document).on('focus', '.js-form-money', function () {
      $(this).mask('#.##0,00', { reverse: true });
    });
  },
};

const s = common.settings,
  _this = common;

export default _this;
